import axios from 'axios';
import Cookies from 'universal-cookie';
import $ from 'jquery';
const cookies = new Cookies();

const server = [];

// Signup

export function signup(account) {
    return (dispatch) => {


        dispatch(loginRequest());
        let d = new Date();
        d.setTime(d.getTime() + (6000 * 6000 * 24000));


        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/user/UserSignUp`, account, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': 'application/json'
            }
        }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log("signup   " + res.data.Data);


            if (res.data.StatusCode === "00") {
                cookies.set('domain', 'SelectFashion', { path: '/', d });
                cookies.set('usfid', res.data.Data[0].UserID, { path: '/', expires: d });
                dispatch(loginSuccess(res.data.Data));

            } else {
                dispatch(loginFailure());
            }
        }).catch(e => {
            dispatch(loginFailure());
            console.log(e);
        })

    }
}
// Login

export function login(account) {
    return (dispatch) => {


        dispatch(loginRequest());

        let d = new Date();
        d.setTime(d.getTime() + (6000 * 6000 * 24000));

        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/user/Authentication`, account, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': 'application/json'
            }
        }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));



            if (res.data.StatusCode === "00") {
                cookies.set('domain', 'SelectFashion', { path: '/', expires: d });
                cookies.set('usfid', res.data.Data[0].UserID, { path: '/', expires: d });


                dispatch(loginSuccess(res.data.Data));

            } else {
                console.log("LOGIN_FAILED dispatch");
                dispatch(loginFailure());
            }
        }).catch(e => {
            dispatch(loginFailure());
            console.log(e);
        })

    }
}

export function loginRequest() {
    return {
        type: 'LOGIN_REQUEST'
    }
}

// Get USer info

export function getUserNameByUserID() {
    return (dispatch) => {


        var uid = {
            "productID": cookies.get("usfid")
        }
        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/user/getUserNameByUserID`, uid, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': 'application/json'
            }
        }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));

            if (res.data.StatusCode === "00") {

                dispatch(getUserNameByUserIDSuccess(res.data.Data));

            } else {
                dispatch(loginFailure());
            }
        }).catch(e => {
            dispatch(loginFailure());
            console.log(e);
        })

    }
}

export function getUserNameByUserIDSuccess(username) {
    return {
        type: "USERNAME_SUCCESS",
        username: username
    }
}

export function loginSuccess(userInfo) {

    return {
        type: "LOGIN_SUCCESS",
        userInfo: userInfo
    }
}


export function loginFailure() {

    console.log("LOGIN_FAILED action success");
    return {
        type: "LOGIN_FAILED"
    }
}

//Logout 


export function logout() {
    return {
        type: "LOGOUT"
    }
}



//Payment Actions


export function savePayment(payment) {
    return (dispatch) => {

        let paymentJSON = JSON.stringify(payment);

        return axios.post(`${server}/api/user/SavePayment`, paymentJSON, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': 'application/json'
            }
        }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            if (res.data.StatusCode === "00") {
                dispatch(savePaymentSuccess());
            }
        }).catch(e => {
            console.log(e);
        })


    }
}

export function savePaymentSuccess() {
    return {
        type: "PAYMENT_SUCCESS"
    }
}


// Orders Actions

export function getUserOrders(cat) {

    var morph_api_url = 'https://api.morph.io/SelectSoft/select_jigar/data.json';
    var morph_api_params = {
        // Keep this key secret!
        key: '7hDDGSosf23K7474Bd4P',
        query: "Select product.ProductID ,product.Price, product.Brand_Name ,images.ImageURL from product,images where product.SKU = Images.SKU and images.display = 1 order by RANDOM()"
    };
    return (dispatch) => {


        $.ajax({
            url: morph_api_url + '?' + $.param(morph_api_params),
            dataType: 'jsonp',
            success: function(data) {
                let res = JSON.parse(JSON.stringify(data));
                dispatch(getSavedProductsByUserIDSuccess(res));
            }
        });
    }
}

export function getUserOrdersSuccess(productsList) {
    console.log("I am in product list action");
    return {
        type: "LOAD_PRODUCTS",
        productsList: productsList
    }
}
export function getSavedProductsByUserID(uid) {

    console.log("holaaa uid" + uid);
    var gid = {
        "productID": uid
    }
    console.log("holaaa gid" + gid);
    return (dispatch) => {


        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/saved/getSavedProductByUserID`, gid, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(getSavedProductsByUserIDSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}
export function getSavedProductsByUserIDSuccess(savedItem) {
    console.log("I am in product list action");
    return {
        type: "LOAD_SAVEDPRODUCTS",
        savedItem: savedItem
    }
}



// Category Actions

export function getCategories() {
    return (dispatch) => {

        return axios.get(`${server}/api/category/GetAllCategories`).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            dispatch(getCategoriesSuccess(res.data.Data));
        })
    }
}


export function getCategoriesSuccess(categories) {
    return {
        type: "GET_CATEGORIES",
        categories: categories
    }
}


//Products Actions


export function getAllProducts() {
    return (dispatch) => {

        dispatch(fetchingProducts());

        return axios.get(`${server}/api/Product/GetAllProducts`).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res.data.Data);
            dispatch(getAllProductsSuccess(res.data.Data));
        })
    }
}

export function fetchingProducts() {
    return {
        type: 'FETCHING_PRODUCTS'
    }
}

export function getAllProductsSuccess(products) {
    return {
        type: 'GET_ALL_PRODUCTS',
        products: products
    }
}

export function getSingleProduct(id) {
    id = id.split('=')[1]
    return (dispatch) => {

        return axios.get(`https://selectabe20190603082437.azurewebsites.net/api/product/GetProductByID?id=${id}`).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log("lpc" + res.data);
            dispatch(getSingleProductSuccess(res.data));
        })
    }
}

export function getSingleProductSuccess(product) {
    return {
        type: 'GET_SINGLE_PRODUCT',
        product: product
    }
}
// Place an order

export function createOrder(order) {

    return (dispatch) => {

        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/order/createOrder`, order, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(createOrderSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}
export function createOrderSuccess(ordersList) {
    return {
        type: 'CREATE_ORDER',
        ordersList: ordersList
    }
}
export function createOrderUserAccount(orderacc, order) {

    let d = new Date();
    d.setTime(d.getTime() + (6000 * 6000 * 24000));
    return (dispatch) => {

        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/order/createOrderUserAccount`, orderacc, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.data.StatusCode == "00") {
                cookies.set('domain', 'SelectFashion', { path: '/', expires: d });
                cookies.set('usfid', res.data.Data[0].UserID, { path: '/', expires: d });
                order["userID"] = res.data.Data[0].UserID
                dispatch(createOrder(order));
            } else {
                alert("something went wrong hola");
            }
        })
    }
}
export function createOrderUserAccountSuccess(ordersList) {
    return {
        type: 'CREATE_ORDER',
        ordersList: ordersList
    }
}


export function setCategoryId(id) {
    return {
        type: "SET_CATEGORY_ID",
        id: id
    }
}



export function updateCart(cart) {
    return {
        type: 'UPDATE_CART',
        cart: cart
    }
}


// Password Recovery Actions

export function forgotPassword(account) {
    return (dispatch) => {

        return axios.post(`${server}/api/account/ForgotPassword`, account).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res.data.Data);
            dispatch(forgotPasswordSuccess());
        })
    }
}

export function forgotPasswordSuccess() {
    return {
        type: 'FORGOT_SUCCESS'
    }
}


export function resetPassword(account) {
    return (dispatch) => {

        return axios.post(`${server}/api/account/ResetPassword`, account).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res.data.Data);
            dispatch(resetPasswordSuccess());
        })
    }
}

export function resetPasswordSuccess() {
    return {
        type: 'RESET_SUCCESS'
    }
}


// get sale product 


export function GetOnSaleproducts() {



    return (dispatch) => {

        return axios.get(`https://selectabe20190603082437.azurewebsites.net/api/product/GetOnSaleProducts`, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(GetOnSaleproductssSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}

export function GetOnSaleproductssSuccess(onSaleProductList) {
    console.log("I am in product list action");
    return {
        type: "LOAD_ONSALE",
        onSaleProductList: onSaleProductList
    }
}


// get sale popular 
export function getProductFromMorphJigar() {

    var morph_api_url = 'https://selectfashion.herokuapp.com/getAllProducts';
    var morph_api_params = {
        // Keep this key secret!
        key: '7hDDGSosf23K7474Bd4P',
        query: "Select product.ProductCount,product.Title ,product.ProductID ,product.Price, product.Brand_Name ,images.ImageURL from product,images where product.SKU = Images.SKU and product.display = 1 and images.display = 1 order by RANDOM()"
    };

    return (dispatch) => {
        $.ajax({
            url: morph_api_url,
            dataType: 'json',
            success: function(data) {
                let res = JSON.parse(JSON.stringify(data));
                dispatch(JigarSuccess(res.data));

            }
        });
    }
}
export function getJigarKey() {

    var morph_api_url = 'https://api.morph.io/SelectSoft/select_jigar/data.json';
    var morph_api_params = {
        // Keep this key secret!
        key: '7hDDGSosf23K7474Bd4P',
        query: "select * from JigarKey"
    };

    return (dispatch) => {
        $.ajax({
            url: morph_api_url + '?' + $.param(morph_api_params),
            dataType: 'jsonp',
            success: function(data) {
                let res = JSON.parse(JSON.stringify(data));
                dispatch(JigarKeySuccess(res[0].JigarKey));

            }
        });
    }
}
export function JigarKeySuccess(key) {
    return  {
        type: "JIGAR_KEY",
        JigarKey: key
    }
}
export function JigarSuccess(data) {
    return {
        type: "JIGAR_PRODUCT",
        JigarProduct: data
    }
}
export function getPopularDresses() {



    return (dispatch) => {

        return axios.get(`https://selectabe20190603082437.azurewebsites.net/api/product/getPopularDresses`, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(getPopularDressesSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}

export function getPopularDressesSuccess(popularDressesList) {
    return {
        type: "LOAD_POPULAR",
        popularDressesList: popularDressesList
    }
}
export function GetAllImportedProducts() {



    return (dispatch) => {

        return axios.get(`https://selectabe20190603082437.azurewebsites.net/api/product/GetAllImportedProducts`, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(GetAllImportedProductsSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}

export function GetAllImportedProductsSuccess(importedproductList) {
    console.log("I am in product list action");
    return {
        type: "LOAD_IMPORTED",
        importedproductList: importedproductList
    }
}

// Orders Actions

export function getProductByBrandName(brandP) {



    return (dispatch) => {


        return axios.post(`https://selectabe20190603082437.azurewebsites.net/api/product/getProductByBrandName`, brandP, { headers: { Origin: "http://localhost:3000", Host: "http://localhost:55414" } }).then((response) => {
            let res = JSON.parse(JSON.stringify(response));
            console.log(res);
            if (res.statusText === "OK") {
                dispatch(getProductByBrandNameSuccess(res.data));
            } else {
                alert("something went wrong");
            }
        })
    }
}

export function getProductByBrandNameSuccess(brandsProduct) {
    console.log("I am in product list action");
    return {
        type: "LOAD_BRANDS",
        brandsProduct: brandsProduct
    }
}